/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { LocationObject } from './locationObject';
import { UserBasic } from './userBasic';
import { UserRelationToGroup } from './userRelationToGroup';
import { ValidityPeriod } from './validityPeriod';

export interface ProjectBasic { 
    entity_id: string;
    title: string;
    type: string;
    specialities: Array<CategoryBasicView>;
    location: LocationObject;
    creator: UserBasic;
    created: Date;
    validity_period: ValidityPeriod;
    actor_role: UserRelationToGroup;
}